import Vue from '../node_modules/vue/dist/vue.common';

class MessageBus {
    static getInstance() {
        if(!MessageBus.instance) {
            MessageBus.instance = new Vue();
        }
        return MessageBus.instance;
    }
}

// static array to hold generated modals
Object.defineProperty(MessageBus, 'instance', {
    get: function() { return this.hasOwnProperty('_instance') ? this._instance : void 0; },
    set: function(v) { this._instance = v; }
});

export { MessageBus as default}


// WEBPACK FOOTER //
// ./js/message-bus.js